// extracted by mini-css-extract-plugin
export default {"body":"style_body__xqGAv","loader":"style_loader__IXyXO","pgfill":"style_pgfill__Z-Z-U"};